export default "__VITE_ASSET__Dy9YvA_N__"